import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import "bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css'
import * as API from "./http/api"
import mitt from 'mitt'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import {global_objects} from "./global"
import {Toaster} from "@meforma/vue-toaster";
import {IonicVue} from '@ionic/vue';
import '@ionic/core/css/ionic.bundle.css';
import "./assets/css/normalize.css"
import "./assets/css/main.css"
import OneSignalInit from "@/services/oneSignal";

const app = createApp(App)

// Global events
const emitter = mitt()
app.config.globalProperties.emitter = emitter

// Toaster
const toastOptions = {
  position: "top-center",
  maxToasts: 5,
  newestOnTop: true,
  hideProgressBar: true,
  timeout: 5000
}
app.use(Toast, toastOptions)

// Global functions & API
app.config.globalProperties.glb = global_objects
app.config.globalProperties.API = API



app.use(VueAxios, axios)
app.use(store)
app.use(Toaster, {position: 'top'})
app.use(router)
app.use(IonicVue)


router.isReady().then(() => {
  app.mount('#app');
})

// init OneSignal service
document.addEventListener("deviceready", OneSignalInit, false);
